import { motion } from 'framer-motion';
import { Mail, ExternalLink, Clock } from 'lucide-react';

export default function InviteReceivedScene({ onNext }) {
  return (
    <div data-testid="scene-invite-received" className="flex flex-col items-center justify-center h-full px-8">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="w-full max-w-3xl">
        <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-8">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-body font-medium bg-teal-600/10 text-teal-700 mb-3">
            <Mail size={14} /> New User Flow
          </span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tight text-[#0A0A0A]">Invite Received</h2>
          <p className="mt-2 font-body text-base text-[#737373]">Abdul Ahmed receives the email invite</p>
        </motion.div>

        {/* Email mockup */}
        <motion.div initial={{ opacity: 0, y: 20, scale: 0.98 }} animate={{ opacity: 1, y: 0, scale: 1 }} transition={{ delay: 0.3, duration: 0.6 }}
          className="bg-white rounded-2xl border border-black/5 shadow-2xl overflow-hidden">
          {/* Toolbar */}
          <div className="flex items-center gap-3 px-5 py-3 border-b border-[#E5E7EB]">
            <div className="flex gap-1.5"><div className="w-3 h-3 rounded-full bg-[#FF5F57]" /><div className="w-3 h-3 rounded-full bg-[#FEBC2E]" /><div className="w-3 h-3 rounded-full bg-[#28C840]" /></div>
            <div className="flex-1 flex justify-center"><div className="px-4 py-1 rounded-md bg-[#FAFAFA] text-xs font-body text-[#737373]">mail.abc.com — Abdul Ahmed</div></div>
          </div>

          {/* Email content */}
          <div className="p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-teal-600 flex items-center justify-center"><span className="text-white text-sm font-bold">S</span></div>
              <div>
                <p className="font-heading font-bold text-sm text-[#0A0A0A]">Shafafiya Portal</p>
                <p className="font-body text-xs text-[#737373]">noreply@shafafiya.ae</p>
              </div>
              <span className="ml-auto text-xs font-body text-[#737373]">Just now</span>
            </div>

            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.6 }}>
              <h3 className="font-heading font-bold text-xl text-[#0A0A0A] mb-3">You've been invited to Shafafiya</h3>
              <p className="font-body text-sm text-[#737373] leading-relaxed mb-4">
                Dear <span className="font-medium text-[#0A0A0A]">Abdul Ahmed</span>,
              </p>
              <p className="font-body text-sm text-[#737373] leading-relaxed mb-4">
                You have been invited to join the <span className="font-medium text-[#0A0A0A]">Shafafiya platform</span> as a <span className="font-medium text-[#0A0A0A]">Facility Admin</span> for <span className="font-medium text-[#0A0A0A]">Rashid Hospital, UAE</span>.
              </p>
              <p className="font-body text-sm text-[#737373] leading-relaxed mb-6">
                Please click the button below to set up your account and access the portal.
              </p>

              <motion.button
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1.0 }}
                className="flex items-center gap-2 px-6 py-3 rounded-xl bg-teal-600 text-white font-body font-bold text-sm cursor-pointer"
                onClick={onNext}
              >
                <ExternalLink size={16} /> Accept Invite & Sign In
              </motion.button>

              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.3 }}
                className="mt-6 flex items-center gap-2 px-4 py-2.5 rounded-lg bg-amber-50 border border-amber-200">
                <Clock size={14} className="text-amber-600" />
                <p className="font-body text-xs text-amber-700">This invite expires in <span className="font-bold">3 days</span>. Please accept before it expires.</p>
              </motion.div>
            </motion.div>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
}
